import React, { Component, Fragment } from 'react';
import { SITE_ORIGIN } from 'constants/site';
import { SAILTHRU_CUSTOMER_ID } from 'constants/vendor';

// Source JS (see minified below)
/*
const SCRIPT = `
  (function() {
    var s = document.createElement('script');
    s.src = 'https://ak.sail-horizon.com/spm/spm.v1.min.js';
    s.async = true;
    s.onload = function() {
      window.Sailthru.init({ customerId: '${SAILTHRU_CUSTOMER_ID}', autoTrackPageview: false, isCustom: true });
      if (window._sailthru_q && window._sailthru_q.length) {
        for (var i = 0; i < window._sailthru_q.length; i++) {
          window.Sailthru.track('pageview', {
            url: window._sailthru_q[i]
          });
        }
        delete window._sailthru_q;
      }
    };
    document.head.appendChild(s);
  }());
`;
*/
// Minified JS
const SCRIPT = `!function(){var i=document.createElement("script");i.src="https://ak.sail-horizon.com/spm/spm.v1.min.js",i.async=!0,i.onload=function(){if(window.Sailthru.init({customerId:"${SAILTHRU_CUSTOMER_ID}",autoTrackPageview:!1,isCustom:!0}),window._sailthru_q&&window._sailthru_q.length){for(var i=0;i<window._sailthru_q.length;i++)window.Sailthru.track("pageview",{url:window._sailthru_q[i]});delete window._sailthru_q}},document.head.appendChild(i)}();`;

class Sailthru extends Component {
  static Head() {
    if (!SAILTHRU_CUSTOMER_ID) {
      return null;
    }
    return (
      <Fragment>
        <script dangerouslySetInnerHTML={{ __html: SCRIPT }} />
      </Fragment>
    );
  }
  render() {
    return null;
  }
}

Sailthru.pageView = path => {
  if (typeof window === 'undefined' || !SAILTHRU_CUSTOMER_ID) {
    return;
  }

  const url = `${SITE_ORIGIN}${path}`;

  if ('Sailthru' in window) {
    window.Sailthru.track('pageview', {
      url
    });
  } else {
    window._sailthru_q = window._sailthru_q || [];
    window._sailthru_q.push(url);
  }
};

export default Sailthru;
